export enum StoryTabType {
  storyTab1 = 'storyTab1',
  storyTab2 = 'storyTab2',
  storyTab3 = 'storyTab3',
  storyTab4 = 'storyTab4',
  storyTab5 = 'storyTab5',
  pinnedStoryTab = 'pinnedStoryTab',
}
